module.exports = __webpack_public_path__ + "static/media/400123_01.61fdb99a.png";